import $ from 'jquery';

const $window = $(window);
const debounceDelay = 250;
const breakpoint_sm_max = 767;

function initialCheckFit() {
    return new Promise(function (resolve, reject) {
        $('.header').one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
            resolve(checkFit($('.header').height()));
        });
    });
}

function checkFit(headerHeigth = $('.header').height()) {
    if ($window.outerWidth() > breakpoint_sm_max) {
        if ($('.sidebar').outerHeight() > $window.outerHeight() - headerHeigth - 60) {
            $('.sidebar').addClass('nonsticky');
        } else {
            $('.sidebar').removeClass('nonsticky');
        }
    } else {
        if ($('.sidebar').hasClass('is-menu')) {
            $('.sidebar').removeClass('nonsticky');
        }
    }
}

function toggleSidebar() {
    if ($('.sidebar').hasClass('active')) {
        hideSidebar();
    } else {
        showSidebar();
    }
}

function showSidebar() {
    $('.post__sidebar').addClass('ontop');
    $('.sidebar')
        .stop()
        .animate({ width: '100%', padding: '30px' }, 500, function () {
            $('.sidebar').addClass('active');
            $('.sidebar__heading, .sidebar__menu').stop().animate({ opacity: 1 }, 500);
        });
}

function sudoShowSidebar() {
    $('.post__sidebar').removeClass('ontop');
    $('.sidebar').removeAttr('style');
    $('.sidebar__heading, .sidebar__menu').removeAttr('style');
}

function animateSidebarClose() {
    $('.sidebar')
        .stop()
        .animate({ width: 0, padding: '30px 0' }, 500, function () {
            $('.post__sidebar').removeClass('ontop');
            if ($window.outerWidth() > breakpoint_sm_max) {
                sudoShowSidebar();
            }
        });
}

function hideSidebar() {
    if ($window.outerWidth() <= breakpoint_sm_max) {
        if ($('.sidebar').hasClass('active')) {
            $('.sidebar').removeClass('active');

            if ($('.sidebar__heading').length || $('.sidebar__menu').length) {
                $('.sidebar__heading, .sidebar__menu')
                    .stop()
                    .animate({ opacity: 0 }, 500, function () {
                        if ($window.outerWidth() > breakpoint_sm_max) {
                            sudoShowSidebar();
                            return;
                        }
                        animateSidebarClose();
                    });
            } else {
                animateSidebarClose();
            }
        }
    } else {
        sudoShowSidebar();
    }
}

$(function () {
    initialCheckFit();
    let timeout = false;
    $window.on('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            checkFit();
        }, debounceDelay);
    });

    var lastWindowWidth = $window.width();
    $window.on('resize', function () {
        var windowWidth = $window.width();
        if (lastWindowWidth !== windowWidth) {
            hideSidebar();
            lastWindowWidth = windowWidth;
        }
    });

    $('.navigation__hamburger').on('click', function () {
        $('.post__sidebar').removeClass('ontop');
        hideSidebar();
    });
    $('.sidebar__toggle').on('click', toggleSidebar);
});
